import { useMutation, useQueryClient } from "react-query";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

export interface IAddResponseCodeRequest {
  id: number;
  errorCode: string;
  errorSource: string;
  errorCodeDesc: string;
  errorDetail: string;
  integrationCode: string;
  internalErrorCode: string;
  internalErrorCodeDesc: string;
  bankName: string;
}

async function addResponseCode(
  params: IAddResponseCodeRequest
): Promise<any> {
  const { data } = await axiosInstance.post("/ResponseCode/AddResponseCode", params);
  return data;
}

export function useAddResponseCode() {
  const queryClient = useQueryClient();
  return useMutation((params: IAddResponseCodeRequest) => addResponseCode(params), {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.responseCodes);
    },
  });
}
